/*@flow*/
import type { Node } from 'react';
import { createElement } from 'react';
import type { ComponentPropsT } from '../types';
import getTemplate from '../util/getTemplate';
import getTransformer from '../util/getTransformer';
import { useLocals, useField, useTransformedValue } from '../hooks';

export default function DateTimeComponent(props: ComponentPropsT): Node {
  const { path } = props;
  const { fieldOptions, fieldValue } = useField(path);
  const transName = 'datetime';
  const transformer = getTransformer(fieldOptions, transName);
  const locals = useLocals(path, { transformer });
  const order = fieldOptions.order || ['M', 'D', 'YY'];
  const template = getTemplate(fieldOptions, 'date');
  useTransformedValue(fieldValue, transformer, locals.onChange);
  return createElement(template, { ...locals, order });
}
